import { CircularProgress } from "@mui/material";
import { ApexOptions } from "apexcharts";
import * as React from "react";
import ReactApexChart from "react-apexcharts";
import { AuthContext } from "../../context/AuthContext";


interface ChartData {
  series: number[];
  labels: string[];
}

const InvoicesProcessingAcceptedVs = () => {
  const { token } = React.useContext(AuthContext) || {};
  const [chartData, setChartData] = React.useState<ChartData>({
    series: [],
    labels: [],
  });

  const [loading, setLoading] = React.useState<boolean>(false);

  React.useEffect(() => {
    const fetchData = async () => {
      let options = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      setLoading(true);
      try {
        const response = await fetch("/api/invoices/vs", options);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        const data = result.data;

        // Filtrar y transformar los datos
        const processingCount =
          data.find((item: any) => item.status === "processing")?.count || 0;
        const acceptedCount =
          data.find((item: any) => item.status === "success")?.count || 0;

        setChartData({
          series: [processingCount, acceptedCount],
          labels: ["Procesando", "Aceptados"],
        });
      } catch (error) {
        console.error("Error fetching invoices data:", error);
      }

      setLoading(false);
    };

    fetchData();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const chartOptions: ApexOptions = {
    chart: {
      type: "pie",
    },
    labels: chartData.labels,
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
  };

  return (
    <>
      {!loading ? (
        <ReactApexChart
          options={chartOptions}
          series={chartData.series}
          type="pie"
          height={350}
        />
      ) : (
        <CircularProgress />
      )}
    </>
  );
};

export default InvoicesProcessingAcceptedVs;
